export const trackFa = (event: any) => {
  if (window && (window as any).__fa) {
    (window as any).__fa.push(['trackEvent', event]);
  }
};
